import { createPath, useLocation } from 'react-router'

/**
 * Records the current route before opening an in-app document.
 *
 * The document viewer uses it to restore the route and its navigation state.
 */
export const useDocumentOrigin = () => {
  const location = useLocation()

  return { from: createPath(location), fromState: location.state ?? null }
}
